import { render, staticRenderFns } from "./DeviceManagement.vue?vue&type=template&id=f0b1b8f8&scoped=true&"
import script from "./DeviceManagement.vue?vue&type=script&lang=js&"
export * from "./DeviceManagement.vue?vue&type=script&lang=js&"
import style0 from "./DeviceManagement.vue?vue&type=style&index=0&id=f0b1b8f8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0b1b8f8",
  null
  
)

export default component.exports